var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.typeCountdown == "lotto"
    ? _c(
        "p",
        {
          staticClass: "text-h6",
          class: _vm.textPosition,
        },
        [_vm._v("\n  " + _vm._s(_vm.formattedTimeLeft) + "\n")]
      )
    : _c(
        "p",
        {
          staticClass: "text-h4",
          class: _vm.textPosition,
        },
        [_vm._v("\n  " + _vm._s(_vm.formattedTimeLeft) + "\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }